import { useAddToCart } from "@trydig/centra/client";
import Image from "next/image";
import { PlusIcon } from "@/components/icons/Plus";
import { Skeleton } from "@/components/ui/Skeleton";
import { ProductPrice } from "@/features/products/ProductDetailsPage/components/ProductPrice";
import { Link } from "@/i18n/routing";
import type { KaosProduct } from "@/lib/centra";
import styles from "./UpsellProduct.module.css";

export interface UpsellProductProps {
	item: KaosProduct;
}

export const UpsellProduct = ({ item }: UpsellProductProps) => {
	const media = item?.media?.standard?.[0];

	const addToCart = useAddToCart();

	const itemId = item.items?.[0].item;

	if (!itemId) return null;

	return (
		<article className={styles.root}>
			<div className={styles.image}>
				<Image src={media || "/fallback-image.jpg"} alt="product" fill />
				<button
					type="button"
					className={styles.button}
					onClick={() => {
						addToCart.mutate({
							itemId,
						});
					}}
				>
					<PlusIcon />
				</button>
			</div>
			<div className={styles.sub}>
				<Link
					className={styles.name}
					href={
						item.categoryUri && item.uri
							? `${item.categoryUri}/${item.uri}`
							: "/"
					}
					aria-label={`View details about ${item.name}`}
				>
					{item.name}
				</Link>
				<span className={styles.color}>{item.variantName}</span>
			</div>
			<ProductPrice
				className={styles.price}
				discountedPrice={(item as { price?: string })?.price ?? ""}
				price={
					(item as { priceBeforeDiscount?: string })?.priceBeforeDiscount ?? ""
				}
			/>
		</article>
	);
};

export const UpsellProductSkeleton = () => {
	return (
		<article className={styles.root}>
			<Skeleton className={styles.image} />

			<div className={styles.sub}>
				<Skeleton fitContent>
					<span className={styles.name}>Lorem, ipsum.</span>
				</Skeleton>
				<Skeleton fitContent>
					<span className={styles.color}>Lorem, ipsum dolor.</span>
				</Skeleton>
			</div>
			<Skeleton fitContent>
				<span className={styles.price}>Lorem, ipsum.</span>
			</Skeleton>
		</article>
	);
};
